const primaryColors = [
  "#EE7700",
  "#7E22CE",
  "#DD2222",
  "#FFC107",
  "#00994D",
  "#1565C0",
];

export { primaryColors };
